import React, { Component } from "react";
import {Link} from "react-router-dom";


class Service4 extends Component {
  render() {
    return (
        <div>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Pre-owned Equipment</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Pre-owned Equipment</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            {/* ===============  faq wrapper start =============== */}
            <div className="faq-wrapper pt-40">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="faq-wrap">
                            <div className="p-timeline-overview">
                              <br/>  <h5>Pre-owned Equipment</h5><br/>
<p>While used Machinery/Equipment is more affordable than purchasing new equipment, if not purchased from a reputable provider, it can often cost you more in the long run. It completely based on the reliable of the products and suppliers who deal with it.</p><br/>
<p>From start to finish, here’s a behind-the-scenes look at our pre-owned equipment process that explains how we source and prepare each piece of used equipment before delivery to our customer.</p><br/>
<p style={{fontWeight:'bold'}}>Getting the Pre-Owned Equipment</p>
<p>We have a very selective process for the acquisition of used equipment. A large percentage of these machines are sourced from our reliable customers/suppliers, which means they were originally bought new and have been carefully maintained by their factory-trained technicians since that time.
</p><br/>
<p style={{fontWeight:'bold'}}>Refurbishing the Equipment</p>
<p>Once we’ve got the product in our possession, we provide a clear, honest assessment of its condition.</p><br/>
<p>Our goal is to help the customer by producing equipment that is as close to the original as possible.</p><br/>
<p>To refurbish something is to restore it to its original condition. In terms of equipment, refurbishment consists of reassembling and replacing components to restore the equipment to its state when originally manufactured, which is why the process is often referred to as remanufacturing.</p><br/>
<p>Finally we transform the equipment from a “used” into “pre-owned”:</p>


                            </div><br/><br/>



                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* ===============  faq wrapper end =============== */}
        </div>
    );
  }
}

export default Service4;
